import { render, staticRenderFns } from "./AddVendors.vue?vue&type=template&id=29e3cbb2&scoped=true&"
import script from "./AddVendors.vue?vue&type=script&lang=js&"
export * from "./AddVendors.vue?vue&type=script&lang=js&"
import style0 from "./AddVendors.vue?vue&type=style&index=0&id=29e3cbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3cbb2",
  null
  
)

export default component.exports